import type { Metadata } from "@/lib/head";
import { Link } from "@/lib/nav";

import Pill from "@buildpy/ui/pill";
import { messagePhotoPath } from "@buildpy/core/modules/message/photo-path";
import { MESSAGE_CLOSED_MESSAGE } from "@buildpy/core/modules/message/rules";
import MessageCompose from "@/modules/message/ui/message-compose";
import MessageList from "@/modules/message/ui/message-list";
import type { ProjectMessagesView } from "@buildpy/core/views/g3b/project-messages";
import PageHeader from "@/shell/page-header";

export const metadata: Metadata = { title: "고객 대화" };

interface Props {
  id: string;
  data: ProjectMessagesView;
}

// 고객 대화 — 한 현장의 줄기 전체. 조직 사람이면 누구나 쓰고, 열면 직원 쪽 읽음 표시가 옮겨진다(읽기 core 가 옮긴다).
const Page = ({ id, data }: Props) => {
  const { unread } = data;

  return (
    <div className="mx-auto flex w-full min-w-0 max-w-2xl flex-col gap-y-4" data-testid="project-messages">
      <PageHeader
        meta={
          <span className="flex flex-wrap items-center gap-x-2">
            <Link
              className="underline-offset-2 hover:underline"
              data-testid="project-messages-project-link"
              href={`/app/projects/${id}`}>
              {data.projectTitle || "현장"}
            </Link>
            <span aria-hidden>·</span>
            <span>{data.customerName}</span>
            {unread > 0 && (
              <span data-testid="project-messages-unread">
                <Pill tone="primary">새 글 {unread}</Pill>
              </span>
            )}
          </span>
        }
        title="고객 대화"
      />

      <MessageList
        change={data.closed ? undefined : { target: { kind: "staff", projectId: id }, who: { kind: "STAFF", member_id: data.viewerMemberId } }}
        emptyText="아직 주고받은 글이 없습니다."
        messages={data.messages}
        photoPathOf={(m) => messagePhotoPath(id, m.id)}
        testId="project-message-list"
        viewer="STAFF"
      />

      {data.closed ? (
        <p className="text-sm text-muted-foreground" data-testid="project-messages-closed">
          {MESSAGE_CLOSED_MESSAGE}
        </p>
      ) : (
        <MessageCompose
          placeholder="고객에게 남길 말을 적어 주세요"
          target={{ kind: "staff", projectId: id }}
          testId="project-message-form"
        />
      )}
    </div>
  );
};

export default Page;
